// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1t8np","inputWrap":"CustomTip_inputWrap__21OY7"};